import { render, staticRenderFns } from "./BalanceEnjoy.vue?vue&type=template&id=e35a4dea"
import script from "./BalanceEnjoy.vue?vue&type=script&lang=js"
export * from "./BalanceEnjoy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports